import React from "react";
import { Helmet } from "react-helmet";

interface JsonLdProps {
  schema: Record<string, any> | Record<string, any>[];
}

/**
 * Injects a JSON-LD structured data script tag into <head> via react-helmet.
 * Usage: <JsonLd schema={{ "@context": "https://schema.org", "@type": "...", ... }} />
 */
const JsonLd: React.FC<JsonLdProps> = ({ schema }) => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
  </Helmet>
);

export default JsonLd;
